import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@groot-components/shared/mixins/props';

/**
 * Select Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Select can be empty
     */
    @Prop({ type: Boolean }) allowEmpty!: boolean;

    /**
     * Multiselect Mode
     */
    @Prop({ type: Boolean }) multiple!: boolean;

    /**
     * Use as tag select
     */
    @Prop({ type: Boolean }) taggable!: boolean;

    /**
     * Label key
     */
    @Prop({ default: 'label' }) labelField!: string;

    /**
     * Value key
     */
    @Prop({ default: 'value' }) valueField!: string;

    /**
     * Custom Label Method
     */
    @Prop() customLabel!: Function;

    /**
     * Endpoint to search for options
     */
    @Prop() endpoint!: {[k: string]: any};

    /**
     * Select options list
     */
    @Prop({ default: () => [] }) options!: Array<object>;

    /**
     * Search param name to send in api request
     */
    @Prop({ default: 'search' }) search!: string;

    /**
     * Placeholder of the tag
     * If _taggable_ is true
     */
    @Prop() tagPlaceholder! : string;

    /**
     * Close list after select
     * This is _true_ for multiselect
     */
    @Prop({ type: Boolean }) closeOnSelect!: boolean;

    /**
     * Group Select Value Field Name
     */
    @Prop() groupValues: string;

    /**
     * Group Select Label Field Name
     */
    @Prop() groupLabel: string;

    /**
     * Is Group Select
     */
    @Prop() groupSelect: boolean;

    /**
     * Hide SingleLabel Title
     */
    @Prop({ type: Boolean }) noSingleLabelTitle!: boolean;
}

export default Props;
